import {
  composeValidations,
  pathAvailableValidation,
  pathValidation,
} from './common.js';

export function createServicePluginValidation(projectFolder: string) {
  return composeValidations([
    [pathAvailableValidation(projectFolder), 'Plugin name must be unique'],
    [
      (path: string) => path.length < 20,
      'Plugin name must be shorter than 20 characters',
    ],
    [
      pathValidation,
      'The plugin folder must be a valid path ([a-z0-9-/]+) and must not start with a dot.',
    ],
  ]);
}
